<div class="card mt-4">
  <h4 class="card-header card-title">Filter</h4>

  <div class="card-body">
    <div class="row">
      <div class="col-12 col-xl-6">
        <div class="row my-1">
          <div class="col-4 mt-2">Start Date</div>
          <div class="col-8">
            <div class="input-group btn-group">
              <input
                class="form-control"
                placeholder="Beginning of recording"
                name="dpFrom"
                ngbDatepicker
                #dpFrom="ngbDatepicker"
                (click)="dpFrom.toggle()"
                [(ngModel)]="from"
              />
              <div class="input-group-append">
                <button class="btn" (click)="dpFrom.toggle()" type="button">
                  <fa-icon icon="calendar"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-1">
          <div class="col-4 mt-2">End Date</div>
          <div class="col-8">
            <div class="input-group btn-group">
              <input
                class="form-control"
                placeholder="Today"
                name="dpTo"
                ngbDatepicker
                #dpTo="ngbDatepicker"
                (click)="dpTo.toggle()"
                [(ngModel)]="to"
              />
              <div class="input-group-append">
                <button class="btn" (click)="dpTo.toggle()" type="button">
                  <fa-icon icon="calendar"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="options == null" class="col-12 col-xl-6">
        <div class="row my-1">
          <span class="text-secondary">Loading filter options...</span>
        </div>
      </div>
      <div *ngIf="options" class="col-12 col-xl-6">
        <div *ngFor="let option of options" class="row my-1">
          <div class="col-4 mt-2">{{ option.title }}</div>
          <div class="col-8">
            <select class="form-select" (change)="setLabelFilter(option, $event.target.value)">
              <option [selected]="!filter[option.label]"></option>
              <option *ngFor="let v of option.values" [value]="v" [selected]="filter[option.label] === v">{{ v }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="float-end mt-4">
      <div class="btn-group" role="group">
        <button class="btn btn-light" type="button" (click)="reset()">Reset</button>
        <button class="btn btn-primary" type="button" (click)="apply()">Apply Filter</button>
      </div>
    </div>
  </div>
</div>
